var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import debounce from 'lodash/debounce';
var Input = (function (_super) {
    __extends(Input, _super);
    function Input() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Input.prototype.componentDidMount = function () {
        var _this = this;
        var _a = this.props, onChange = _a.onChange, delay = _a.delay, onEnter = _a.onEnter;
        this.onChangeDelay = debounce(onChange, delay);
        if (onEnter) {
            this.onKeyUp = debounce(function (keyCode) {
                if (keyCode === 13 && _this.input) {
                    onEnter(_this.input.value);
                }
            }, delay);
        }
        this.onKeyUp = this.onKeyUp.bind(this);
    };
    Input.prototype.onChangeDelay = function (event) {
        console.error('onChange not bind');
    };
    Input.prototype.onKeyUp = function (code) {
    };
    Input.prototype.render = function () {
        var _this = this;
        return (React.createElement("input", { ref: function (ref) { return _this.input = ref; }, className: "simple-input " + this.props.className, onChange: function (e) { return _this.onChangeDelay(e.target.value); }, onKeyUp: function (e) { return _this.onKeyUp(e.keyCode); }, placeholder: this.props.placeholder }));
    };
    Input.defaultProps = {
        onChange: function () { },
        placeholder: '',
        delay: 200,
        className: ''
    };
    return Input;
}(React.Component));
export default Input;

//# sourceMappingURL=index.js.map
